import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GoogleCallback = () => {
  const location = useLocation();

  useEffect(() => {
    console.log('Callback component mounted');
    console.log('Location:', location);

    // Get the authorization code and state from URL parameters
    const params = new URLSearchParams(location.search);
    const code = params.get('code');
    const state = params.get('state');

    console.log('Code:', code);
    console.log('State:', state);

    if (code) {
      try {
        // Send the code and state to the parent window
        if (window.opener) {
          console.log('Found opener window, sending message');
          window.opener.postMessage(
            {
              type: 'google-oauth-callback',
              code: code,
              state: state
            },
            'https://hotel.onelyk.com'  // Update this to match your domain
          );
          console.log('Message sent to opener');
        } else {
          console.error('No parent window found');
          // If no opener is found, you might want to redirect to a fallback URL
          window.location.href = '/dashboard?auth=failed';
        }
      } catch (error) {
        console.error('Error posting message:', error);
        // Handle the error by redirecting to a fallback URL
        window.location.href = '/dashboard?auth=error';
      }
    } else {
      console.error('No code found in URL parameters');
      // Handle the error by redirecting to a fallback URL
      window.location.href = '/dashboard?auth=nocode';
    }

    // Close this window after sending the message
    const closeTimeout = setTimeout(() => {
      if (window.opener) {
        window.close();
      }
    }, 2000); // Increased timeout to ensure message is sent

    return () => clearTimeout(closeTimeout);
  }, [location]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md">
        <h2 className="text-xl font-semibold mb-4">Authentication in Progress</h2>
        <p className="text-gray-600">Please wait while we complete the authentication process...</p>
      </div>
    </div>
  );
};

export default GoogleCallback; 